import React from 'react';
import PropTypes from 'prop-types';

const MusicAudioSkills = ({ type }) => {
  if (type === 'freelancer') {
    return (
      <>
        <li>
          <a href="/jobs/music-composers">Music composer jobs</a>
        </li>
        <li>
          <a href="/jobs/music-producers">Music producer jobs</a>
        </li>
        <li>
          <a href="/jobs/mixing-engineers">Mixing engineer jobs</a>
        </li>
        <li>
          <a href="/jobs/mastering-engineers">Mastering engineer jobs</a>
        </li>
        <li>
          <a href="/jobs/audio-engineers">Audio engineer jobs</a>
        </li>
        <li>
          <a href="/jobs/sound-designers">Sound designer jobs</a>
        </li>
        <li>
          <a href="/jobs/voiceover-artists">Voiceover artist jobs</a>
        </li>
        <li>
          <a href="/jobs/musicians">Musician jobs</a>
        </li>
      </>
    );
  }

  return (
    <>
      <li>
        <a href="/find/music-composers">Music composers</a>
      </li>
      <li>
        <a href="/find/music-producers">Music producers</a>
      </li>
      <li>
        <a href="/find/mixing-engineers">Mixing engineers</a>
      </li>
      <li>
        <a href="/find/mastering-engineers">Mastering engineers</a>
      </li>
      <li>
        <a href="/find/audio-engineers">Audio engineers</a>
      </li>
      <li>
        <a href="/find/sound-designers">Sound designers</a>
      </li>
      <li>
        <a href="/find/voiceover-artists">Voiceover artists</a>
      </li>
      <li>
        <a href="/find/podcast-producers">Podcast producers</a>
      </li>
      <li>
        <a href="/find/musicians">Musicians</a>
      </li>
      <li>
        <a href="/find/film-composers">Film composers</a>
      </li>
    </>
  );
};

MusicAudioSkills.propTypes = {
  type: PropTypes.string.isRequired,
};

export default MusicAudioSkills;
